
const routes = [

  
  {
    path: '/listusers',
    name: 'listusers',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Configuracion/ListUsersSistema.vue'),
    meta: { public: false, admin:true, adminSagrilaft:true, adminCumplimiento:false, tercero:false } 
  },
  //{
  //  path: '/',
  //  name: 'home',
  //  component: () => import(/* webpackChunkName: "empresa" */ '@/components/Home.vue'),
  //  meta: { public: false, admin:true, adminSagrilaft:false, adminCumplimiento:false, tercero:false } 
  //},
  { path: '/', 
    name: 'paginavacia',
    component: { template: '<div></div>' } ,
    meta: { public: false, admin:true, adminSagrilaft:true, adminCumplimiento:true, tercero:false } 
  },
  {
    path: '/generalregistroscumplimiento',
    name: 'generalregistroscumplimiento',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/GeneralRegistrosCumplimientoSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:true, tercero:false }
  },
  {
    path: '/dashboardcumplimiento',
    name: 'dashboardcumplimiento',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/DashBoardCumplimientoSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:true, tercero:false }
  },
  {
    path: '/listempresas',
    name: 'listempresas',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Configuracion/ListEmpresasSistema.vue'),
    meta: { public: false, admin:true, adminSagrilaft:false, adminCumplimiento:true, tercero:false }
  },
  {
    path: '/generalregistrosempresa',
    name: 'generalregistrosempresa',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/GeneralRegistrosEmpresaSistema.vue'),
    props: true,
    meta: { public: false, admin:false, adminSagrilaft:true, adminCumplimiento:false, tercero:false }
  },
  {
    path: '/dashboardempresa',
    name: 'dashboardempresa',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/DashBoardEmpresaSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:true, adminCumplimiento:false, tercero:false }
  },
  {
    path: '/conciliacioncontable',
    name: 'conciliacioncontable',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/ConciliacionContableSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:true, adminCumplimiento:false, tercero:false }
  },
  {
    path: '/registro',
    name: 'registro',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/RegistroSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true }
  },
  {
    path: '/listregistros',
    name: 'listregistros',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/ListRegistrosSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true }
  },
  {
    path: '/listusuariosempresas',
    name: 'listusuariosempresas',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Auth/ListUsuariosEmpresasSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:true, adminCumplimiento:false, tercero:false }
  },
  {
    path: '/registroexterior',
    name: 'registroexterior',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/RegistroExteriorSistema.vue'),
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true }
  },
  {
    path: '/registrovisual',
    name: 'registrovisual',    
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/RegistroVisualSistema.vue'),    
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true },
    props: true,
  },
  {
    path: '/registroexteriorvisual',
    name: 'registroexteriorvisual',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/RegistroExteriorVisualSistema.vue'),    
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true }
  },
  {
    path: '/registrofirmamanuscrita',
    name: 'registrofirmamanuscrita',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/CargarFirmaManuscritaSistema.vue'),    
    meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true }
  },
  {
    path: '/modelozscore',
    name: 'modelozscore',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Financiera/ListModeloZScoreSistema.vue'),    
    meta: { public: false, admin:false, adminSagrilaft:true, adminCumplimiento:false, tercero:false }
  },
  {
    path: '/guiausuario',
    name: 'guiausuario',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/GuiaUsuarioSistema.vue'),    
    meta: { public: false, admin:true, adminSagrilaft:true, adminCumplimiento:true, tercero:false }
  },
  
];

export default routes.map(route => {
  return { ...route }
})